import {cloneDeep, find, get, isEmpty, map, size, sortedUniqBy, trim} from 'lodash';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {Search} from 'semantic-ui-react';
import actionCreators from '../actionCreators';
import {PropertySuggestionsApi} from '../api/PropertySuggestionsApi';
import connected from '../connected';
import {updatePropertySearch} from '../ducks/propertySearch';
import AnalyticsGateway from '../lib/AnalyticsGateway';
import './PropertySearch.scss';
import PropertySearchInput from './PropertySearchInput';

const initialState = {
  isLoading: false,
  searchAddress: '',
  rawPropertySuggestions: [],
  displayResults: [],
};

export class PropertySearch extends Component {
  static propTypes = {
    propertySearch: PropTypes.object,
    reportType: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
  };

  state = {
    ...cloneDeep(initialState),
    isLoading: undefined,
  };

  componentDidMount() {
    this.setState({
      searchAddress: get(this.props.propertySearch, 'singleLineAddress') || '',
      rawPropertySuggestions: [],
      displayResults: [],
    });
    AnalyticsGateway.sendEvent({
      eventName: 'View Signature Dashboard',
      properties: [{label: 'Page', value: 'Signature Dashboard'}]
    });
  }

  resetComponent = () => {
    this.setState(cloneDeep(initialState));
  };

  handleResultSelect = (e, result) => {
    const {dispatch, reportType: {value: reportTypeValue}} = this.props;
    let selectedProperty = find(this.state.rawPropertySuggestions, (p) => p.singleLineAddress === result.result.title);
    if (selectedProperty) {
      let updatedSearchAddress = {
        propertyId: selectedProperty.propertyId,
        singleLineAddress: selectedProperty.singleLineAddress,
      };
      this.setState({
        searchAddress: selectedProperty.singleLineAddress
      });
      dispatch(updatePropertySearch(updatedSearchAddress));
      if (reportTypeValue === 'soi' && !selectedProperty.singleLineAddress.includes(' VIC ')) {
        dispatch(actionCreators.chooseReportType('cma'));
      }
    }
  };

  handleSearchChange = (e, searchAddress) => {
    const {dispatch} = this.props;
    this.setState({isLoading: true, searchAddress: searchAddress.value});
    const trimmedSearchAddress = trim(searchAddress.value);
    if (size(trimmedSearchAddress) < 4) {
      if (isEmpty(searchAddress.value)) {
        const propertySearch = {
          propertyId: null,
          singleLineAddress: null
        };
        dispatch(updatePropertySearch(propertySearch));
        return this.resetComponent();
      }
      return this.setState({
        isLoading: false,
        displayResults: [],
        rawPropertySuggestions: [],
      });
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.performSearch(trimmedSearchAddress);
    }, 500);
  };

  performSearch = (searchAddress) => {
    PropertySuggestionsApi.request(searchAddress, data => {
      const uniqData = sortedUniqBy(data, (i) => i.singleLineAddress);
      this.setState({
        isLoading: false,
        rawPropertySuggestions: uniqData,
        displayResults: map(uniqData, (r) => ({title: r.singleLineAddress}))
      });
    });
  };

  render() {
    const {isLoading, displayResults, searchAddress} = this.state;
    return (
      <Search
        loading={isLoading}
        onResultSelect={this.handleResultSelect}
        onSearchChange={this.handleSearchChange}
        results={displayResults}
        value={searchAddress}
        placeholder={'Enter property address to search'}
        showNoResults={false}
        input={<PropertySearchInput/>}
      />
    );
  }
}

export default connected(PropertySearch);
